export default {
    dashboard: 'Dashboard',
    events: 'Events',
    ticketsets: 'Ticket sets',
    tickets: 'Tickets',
    zones: 'Zones',
    verifyTicket: 'Verify ticket',
    devices: 'Devices',
    statistics: 'Statistics',
    users: 'Users',
    clipboard: 'Clipboard',
    help: 'Help',
    groups: {
        overview: 'Overview',
        tickets: 'Tickets',
        settings: 'Settings'
    },
    auth: {
        login: 'Sign in',
        logout: 'Sign out'
    }
}
